<template>
    <div class="page">
        <div class="centercontainer">
            <img class="logo" :src="assets.logoImage" @click="backHome">
            <a-form-model layout="vertical" :rules="dRules" :model="dFormData" ref="myForm">
                <a-form-model-item class="form-item" label="手机号码" ref="phone" prop="phone">
                    <a-input v-model="dFormData.phone" placeholder="请输入手机号码">
                        <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                    </a-input>
                </a-form-model-item>
                <a-form-model-item class="form-item" label="登录密码" prop="password">
                    <a-input v-model="dFormData.password" type="password" placeholder="请输入密码" @keydown="passwordKeyDownHandler">
                        <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
                    </a-input>
                </a-form-model-item>
                <a-form-model-item class="form-item forgetpassword" v-if="false">
                    <div class="forgetpassword-link" @click="retrievePassword">忘记密码</div>
                </a-form-model-item>
                <a-form-model-item class="form-item">
                    <a-button type="primary" @click="submitForm('myForm')">登录</a-button>
                </a-form-model-item>
                <a-form-model-item class="form-item" v-if="moduleGroup == 2">
                    <a-button type="primary" @click="weixinLogin">微信登录</a-button>
                </a-form-model-item>
                <a-form-model-item class="form-item">
                    <a-button type="primary" @click="register">注册</a-button>
                </a-form-model-item>
            </a-form-model>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue'
    import { mapActions, mapGetters } from 'vuex';
    import { strIsEmpty } from '@/utils/web-utils';
    import { postAction, getAction, deleteAction } from "@/api/api-manage";

    export default {
        name: "Login",
        components: { },
        data(){
            return {
                dFormData: {
                    phone: '',
                    smsCode: '',
                    password: '',
                },
                dRules: {
                    phone: [
                        { required: true, message: '请输入手机号码', trigger: 'blur' },
                    ],
                    /*smsCode: [
                        { required: true, message: '请输入手机验证码', trigger: 'blur' },
                    ],*/
                    password: [
                        { required: true, message: '请输入登录密码', trigger: 'blur' },
                        { min: 6, max: 30, message: '长度在 6 到 30 个字符', trigger: 'blur' }
                    ]
                },
                assets: {
                    logoImage:require('@/assets/logo.png'),
                },

                // 功能模块组别：1=后台，2=web
                moduleGroup: 1,

            }
        },
        methods: {
            ...mapActions([ "userLogin", "userLogout" ]),
            ...mapGetters([ "userInfo"]),
            pageInit:function () {
                this.moduleGroup = window._CONFIG['moduleGroup'];
            },
            getSmsCode: function(){},
            /**  密码输入框按下回车键 */
            passwordKeyDownHandler: function(e) {
                if(e.keyCode == 13){
                    this.submitForm('myForm');
                }
            },
            submitForm: function (formName) {
                let that = this;
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        that.login();
                    } else {
                        return false;
                    }
                });
            },
            login: function () {
                let that = this;
                /*if(strIsEmpty(this.dSmsCode)){
                    Toast('请输入手机验证码');
                    return;
                }*/
                let params = {
                    remember_me: 0,
                    account: this.dFormData.phone,
                    smsCode: '',
                    password: this.dFormData.password,
                    client: 1,
                    loginType: 1,
                };
                this.userLogin(params).then((res) => {
                    console.log('userLogin, result = ' + JSON.stringify(res));
                    that.loginSuccess()
                }).catch((err) => {
                    that.loginFailed(err);
                });
            },
            loginSuccess: function () {
                console.log('loginSuccess...');
                // 后台
                if(this.moduleGroup == 1){
                    this.$router.push({ path: "/main/analysis" }).catch(()=>{
                        console.log('登录跳转首页出错')
                    });
                }
                // web
                if(this.moduleGroup == 2){
                    //console.log('登录成功后， userInfo = ' + JSON.stringify(this.userInfo()));
                    this.$router.push({ path: "/web/index" }).catch(()=>{
                        console.log('登录跳转首页出错')
                    });
                }
            },
            loginFailed: function (err) {
                //Toast('登陆错误 ' + JSON.stringify(err));
                // // code: 1=该手机没有注册, 2=无效用户, 3=手机验证码错误, 4=密码错误
                switch (err.code) {
                    case 1:
                        this.$message.error(err.message);
                        break;
                    case 2:
                        this.$message.error(err.message);
                        break;
                    case 3:
                        this.$message.error(err.message);
                        break;
                    case 4:
                        this.$message.error(err.message);
                        break;
                }
            },
            register:function () {
                this.$router.push({ name: "Register" });
            },
            retrievePassword: function () {
                this.$router.push({ name: "RetrievePassword" });
            },


            /**  返回主页 */
            backHome: function() {
                if(window._CONFIG['moduleGroup'] == 2){
                    this.$router.push({path:"/web/index", params: {}});
                }
            },
            // --------------------------------------------------------------------------------------- 微信登录 start
            /**  微信登录 */
            weixinLogin: function() {
                console.log('微信登录...');
                this.weixinLoginObj = null;
                let that = this;
                this.$nextTick(() => {
                    let params = {};
                    getAction(that.url.getOpenLoginConnectInfo, params).then(res=>{
                        if(res.success){
                            /*that.weixinLoginObj = new WxLogin({
                                self_redirect:true,
                                id: 'divWeixinQrcode',                                  // 需要显示的容器id
                                appid: res.result.appid,                                // 公众号appid wx*******
                                scope: res.result.scope,                                // 网页默认即可
                                redirect_uri: res.result.redirectUri,                   // 授权成功后回调的url
                                state: res.result.state,                                // 可设置为简单的随机数加session用来校验
                                style: 'black',                                         // 提供"black"、"white"可选。二维码的样式
                                href: ''                                                // 外部css文件url，需要https
                            });*/
                            let url = 'https://open.weixin.qq.com/connect/qrconnect?appid='+res.result.appid+'&redirect_uri='+res.result.redirectUri+'&response_type=code&scope='+res.result.scope+'&state='+res.result.state+'#wechat_redirect';
                            window.location.href = url;
                        }else{
                            that.$message.warning(res.message);
                        }
                    }).catch(err => {
                        that.$message.error(err);
                    });
                });
            },
            // --------------------------------------------------------------------------------------- 微信登录 end

            test: function () {

            },
        },
        created() {
            this.pageInit();
        },
    }
</script>

<style lang="less" scoped>

    .page{
        position: absolute;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0px !important;
        background-color: #ffffff;
        .form-item{
            max-width: 300px;
        }
        .forgetpassword{
            text-align: right;
            .forgetpassword-link{
                color: deepskyblue;
            }
        }
    }

</style>
